<h1 mat-dialog-title>Edit roles for {{data.userName}}</h1>
<div mat-dialog-content>
  <form>
    <!-- <div *ngFor="let role of data.roles"> -->

      <mat-checkbox class="example-margin" 
        [checked]="roles.includes('Admin')"
        (change)="editRoles('Admin')">
        Admin
      </mat-checkbox>

      <mat-checkbox class="example-margin" 
        [checked]="roles.includes('Moderator')"
        (change)="editRoles('Moderator')">
        Moderator
      </mat-checkbox>

      <mat-checkbox class="example-margin" 
        [checked]="roles.includes('Member')"
        (change)="editRoles('Member')">
        Member
      </mat-checkbox>
    <!-- </div> -->
  </form>
  
</div>
<div mat-dialog-actions>
  <button mat-button (click)="onNoClick()">Cancel</button>
  <button mat-button [mat-dialog-close]="data" cdkFocusInitial [mat-dialog-close]="data">Submit</button>
</div>